import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { IconDirection } from '../../constants/BatchTypeEnums';

@inject('batchStore')
@observer
class TruckDevice extends Component {
  render() {
    const { device, batchStore } = this.props;
    const batchData = batchStore.getDeviceStatus(device.id);
    const isActive = !!batchData.active;
    const active = isActive ? 'active' : '';
    const direction = device.direction === IconDirection.Right ? 'direction-right': '';
    const logo = device.logo ? batchStore.newAuthStore.companyConfig?.logoFile : '';
    const truckCode = batchStore.running.length ? batchStore.running[0].truckCode : '';

    return (
      <div id={`device-${device.id}`} className={`${active} ${direction} device-gui device-gui--truck`}>
        <div className="device-icon truck-1"/>
        <div className="device-icon truck-2"/>
        {truckCode && <span className="truck-code">{truckCode}</span>}
        {device.logo && <span className="truck-logo"><img alt="" src={`data:image/png;base64,${logo}`}/></span>}
        <button className={`btn btn-sm btn-primary btn-batch btn-batch-green ${active}`}
          onClick={(e) => {
            e.stopPropagation();
            batchStore.deviceStatus.set(device.id, {active: !isActive});
          }}>
          <i className="fa fa-power-off" />
        </button>
        <div className="device-icon logo"/>
      </div>
    );
  }
}

export default deviceDOMHoc(TruckDevice);
